import React, {useEffect, useState} from "react";
import {Prompt} from "react-router";
import i18next from "i18next";
import {useHistory} from "react-router-dom";

const usePreventTransition = (isDirty) => {
  const [hasBlocking, setHasBlocking] = useState(isDirty);
  const history = useHistory();

  /**
   * async to provide redirect after set hasBlocking to {false}, it's need to enable redirect on <PromptComponent/>
   */
  const redirect = async (route) => {
    await setHasBlocking(false);
    history.push(route);
  };

  /** update Blocking status */
  useEffect(() => {
    setHasBlocking(isDirty);
  }, [isDirty]);

  const PromptComponent = () => {
    return <Prompt
      when={hasBlocking}
      message={i18next.t("modal:message.transitionConfirm", "Changes weren't saved. Are you sure you want to leave the page?")}
    />;
  };

  return {
    Prompt: PromptComponent,
    redirect
  };
};

export default usePreventTransition;